import { render, staticRenderFns } from "./intranetLegalRecord.vue?vue&type=template&id=fb3ae3a2&scoped=true"
import script from "./intranetLegalRecord.vue?vue&type=script&lang=js"
export * from "./intranetLegalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ae3a2",
  null
  
)

export default component.exports